import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { isEmpty } from "lodash";

import { DialogFooter } from "../../components/DialogFooter";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { VisitPayInfoLabel } from "../Card/PayInfoLabel";
import { AccessLockedButton } from "./AccessLockedButton";
import { BookVisitButton } from "./BookVisitButton";

interface VisitBottomSheetFooterProps {
  lockedByWorkplaceId?: string;
}

export function VisitBottomSheetFooter(props: VisitBottomSheetFooterProps) {
  const { lockedByWorkplaceId } = props;
  const { visit, case: caseData, isVisitLoading } = useInHomeVisitModalsDataContext();

  const disableBooking = !isDefined(visit) || !isEmpty(visit.attributes.missingRequirements);

  return (
    <DialogFooter withShadow orientation="vertical">
      <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
        {isDefined(visit) && <VisitPayInfoLabel visit={visit} wrapperSx={{ pl: 5 }} />}
        {isDefined(visit) &&
          (isDefined(lockedByWorkplaceId) ? (
            <AccessLockedButton
              lockedByWorkplaceId={lockedByWorkplaceId}
              source="visit-bottom-sheet"
            />
          ) : (
            <BookVisitButton
              visitId={visit.id}
              caseId={caseData?.id}
              isLoading={isVisitLoading}
              isMissingRequirements={disableBooking}
            />
          ))}
      </Stack>
    </DialogFooter>
  );
}
